module.exports = __webpack_public_path__ + "static/media/about-bg.018055f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/about-bg.jpg
// module id = 93
// module chunks = 0